export default __webpack_public_path__ + "static/media/Nova-Scotia_.b74c49e9.jpg";